<template>
  <div class="class2-list-wrap">
    <div class="class2-list" :style="showMoreStyle">
      <div
        v-for="(tab, index) in newClass2List"
        :id="`index-feed-tab-${tab.class2Id}`"
        :key="tab.class2Id"
        :class="[
          'class2-list-item',
          tab.class2Id === class2Id ? 'active' : '',
          class2Id === -999 ? 'up' : ''
        ]"
        :style="styleMap"
        @click="selectItem(tab, index)"
      >
        <div class="name">
          {{ tab.name }}
          <img
            v-if="tab.class2Id === -999"
            src="@/images/cms/common/arrow_up_gray.png"
            class="arrow"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!isShowMore && class2List.length > LIMITCOUNT"
      class="show-more"
      @click="showMore"
    >
      <i class="arrow mcicon-mc_icon_arrowdown"></i>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  // eslint-disable-next-line vue/require-prop-types
  props: ['class2List', 'class2Id', 'class1Id'],

  data() {
    return {
      isShowMore: false,
      LIMITCOUNT: 5
    }
  },
  computed: {
    newClass2List() {
      return [
        ...this.class2List,
        ...(this.isShowMore ? [{ name: '收起', class2Id: -999 }] : [])
      ]
    },
    styleMap() {
      return this.isShowMore ? { 'margin-bottom': '12px' } : {}
    },
    showMoreStyle() {
      return this.isShowMore
        ? {
            height: 'auto',
            'padding-right': '0',
            'flex-wrap': 'wrap'
          }
        : {}
    }
  },
  watch: {
    class1Id(newVal) {
      this.isShowMore = false
    }
  },
  methods: {
    showMore() {
      this.isShowMore = true
    },

    cancelShowMore() {
      this.isShowMore = false
    },
    selectItem(item) {
      if (item.class2Id === -999) {
        return this.cancelShowMore()
      }
      this.$emit('selectClass2', item)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.class2-list-wrap {
  position: relative;
  z-index: 999;
  .class2-list {
    display: flex;
    flex-wrap: nowrap;
    height: 40px;
    box-sizing: border-box;
    padding: 6px 0;
    align-items: center;
    overflow-x: auto;
    padding-right: 40px;
    padding-left: 8px;
    &::-webkit-scrollbar {
      display: none;
    }
    .class2-list-item {
      padding: 0 4px;
      height: 24px;
      background: #f5f5f5;
      border-radius: 4px;
      font-size: 12px;
      color: #595959;
      text-align: center;
      flex-shrink: 0;
      margin: 0 8px 0 0;

      @include flex-row-center;
      &.up {
        background-color: transparent;
      }
      .arrow {
        width: 6px;
        height: 6px;
        position: relative;
        top: 1px;
        left: 1px;
      }
      .name {
        width: 71px;
        @include text-overflow-ellipsis;
        @include text-line-height;
      }
      &.active {
        background: #f031001a;
        color: #f03100;
      }
    }
  }
  .show-more {
    width: 44px;
    height: 36px;
    background: #ffffff;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .arrow {
      font-size: 16px;
      color: #333;
    }
  }
}
</style>
